import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Bar = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${colors.borderGrey};
  border-radius: 28px;
  background: ${colors.lightGrey};
  overflow: visible;
  height: 44px;
`;

export const DotSeparator = styled.span`
  color: ${colors.grey};
  margin: 0 2px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const DatesWrapper = styled.div<{ $isFirst?: boolean }>`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  border-radius: ${({ $isFirst }) => ($isFirst ? '28px 0 0 28px' : '0')};
`;

export const GuestsWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
`;

export const SearchWrapper = styled.div`
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-left: 8px;
`;

export const SearchPill = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  cursor: pointer;
  padding: 0 16px;
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
  white-space: nowrap;
  border-radius: 24px;
  transition: font-weight 0.1s ease;

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }
`;

export const SearchLabel = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: attr(data-text);
    font-weight: ${fonts.weight.semiBold};
    height: 0;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
  }
`;

export const DropdownAnchor = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 200;
`;

export const PipeSeparator = styled.span`
  color: ${colors.grey};
  font-size: ${fonts.size.base};
  line-height: 1;
  flex-shrink: 0;
  pointer-events: none;
  margin-left: ${space[1]};
  margin-right: ${space[1]};
`;

export const CategoryWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-right: 0;
`;

export const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: ${space[4]};
  background: ${colors.lightGrey};
  border: 1px solid ${colors.borderGrey};
  cursor: pointer;
  padding: 0 ${space[4]};
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
  white-space: nowrap;
  border-radius: 24px;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;

export const ChevronIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${colors.fontSecondary};
  transition: transform 0.15s ease;
`;

export const CategoryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 160px;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 200;
  overflow: hidden;
  margin-left: -1px;
`;

export const CategoryOption = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: ${({ $active }) => ($active ? colors.lighterGrey : 'none')};
  border: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.normal)};
  color: ${colors.fontPrimary};
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;
